import ViewAuthenticated from '@/views/AuthenticatedView.vue'
import { authRoutes } from './routes/auth'
import { docsRoutes, apiDocsRoutes } from './routes/docs'
import { deliveryRoutes } from './routes/delivery'
import { signalEmbedRoutes } from './routes/signalEmbed'
import { sampleRoutes } from './routes/sample'
import { accountsRoutes } from './routes/accounts'
import { sourcesRoutes } from './routes/sources'
import { dataOpsRoutes } from './routes/dataOps'
import { signalRoutes } from './routes/signal'
import { amplitudeRoutes } from './routes/amplitude'
import { dashboardsRoutes } from './routes/dashboards'
import { inventoryRoutes } from './routes/inventory'
import { miscRoutes } from './routes/misc'

export const routes = [
    { path: '/', redirect: '/home' },

    // Unauthenticated
    ...authRoutes,
    ...docsRoutes,
    ...deliveryRoutes,
    ...signalEmbedRoutes,
    ...sampleRoutes,
    // Landing page for the Unsubscribe link in notification emails; works with or without a session.
    { path: '/unsubscribe', component: () => import('@/views/UnsubscribeView.vue'), meta: { title: 'Unsubscribe' } },

    // Authenticated shell
    {
        path: '',
        components: {
            default: ViewAuthenticated,
            modalProviderSearch: () => import('@/features/provider-search/views/ProviderSearchView.vue'),
        },
        children: [
            { path: '', redirect: '/home' },
            ...miscRoutes,
            ...apiDocsRoutes,
            ...accountsRoutes,
            ...sourcesRoutes,
            ...dataOpsRoutes,
            ...signalRoutes,
            ...amplitudeRoutes,
            ...dashboardsRoutes,
            ...inventoryRoutes,
        ],
    },

    { path: '/:path(.*)', component: () => import('@/views/NotFoundView.vue') },
]
